/**
 * How a 0–100 score is coloured, everywhere it appears (report dial, Activity
 * calendar, ten-minute snapshots, session list) — one source so a legend can
 * never disagree with a dot. These are display groupings for reading at a
 * glance, not clinical cut-offs; the posture thresholds behind the score live
 * in @erectus/shared THRESHOLDS with their sources.
 */
export const SCORE_BANDS = [
  { min: 80, label: '80+', color: 'var(--color-state-good)' },
  { min: 60, label: '60–79', color: 'var(--color-state-fhp)' },
  { min: 0, label: 'Under 60', color: 'var(--color-state-slouch)' },
] as const;

export function scoreColor(score: number): string {
  return (SCORE_BANDS.find((band) => score >= band.min) ?? SCORE_BANDS[2]).color;
}
